import { jsx } from "react/jsx-runtime";
import {
  stopEventPropagation,
  usePassThroughMouseOverEvents,
  usePassThroughWheelEvents
} from "@tldraw/editor";
import classNames from "classnames";
import React from "react";
const TldrawUiContextualToolbar = React.forwardRef(function TldrawUiContextualToolbar2({ children, className }, toolbarRef) {
  usePassThroughWheelEvents(toolbarRef);
  usePassThroughMouseOverEvents(toolbarRef);
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref: toolbarRef,
      "data-testid": "contextual-toolbar",
      className: classNames("tlui-contextual-toolbar", className),
      onPointerDown: stopEventPropagation,
      children: /* @__PURE__ */ jsx("div", { className: "tlui-menu tlui-buttons__horizontal", role: "toolbar", children })
    }
  );
});
export {
  TldrawUiContextualToolbar
};
//# sourceMappingURL=TldrawUiContextualToolbar.mjs.map
